import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import styles from './index.module.scss';
import EVideo from './EVideo';

export default function E() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.E');

    useEffect(() => {
        const videoLists: any = document.querySelectorAll('.power-ocean-home-E .pc video');
        videoLists.forEach((videoList: any) => {
            const AniContainer = window?.AniContainer;
            AniContainer.create({
                triggerElement: videoList,
                triggerHook: 1,
                offset: 240,
                scrollUpdatePos: true,
                onEnter: () => {
                    videoList.play();
                },
                onLeave: () => {
                    videoList.pause();
                    videoList.currentTime = 0;
                },
            });
        });

        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1080;
        const AniContainer = window?.AniContainer;
        AniContainer.create({
            asyncFromTo: [
                ['.power-ocean-home-E .pc .sec5-top .box1-ani', { opacity: 1, y: 0 }, { opacity: 0, y: -150 }, 0.4],
                ['.power-ocean-home-E .pc .sec5-top .box2-ani', { opacity: 0, y: 150 }, { opacity: 1, y: 0 }, 0.4],
            ],
            asyncTimeLine: [0, 0.25],
            triggerElement: '.power-ocean-home-E',
            triggerHook: 1,
            offset: layoutH + 120,
            duration: layoutH - 180,
            scrollUpdatePos: true,
        });

        AniContainer.create({
            syncFromTo: [['.power-ocean-home-E', { y: 0 }, { y: -120 }]],
            triggerElement: '.power-ocean-home-D .pc .img-box',
            triggerHook: 0,
            offset: 0,
            duration: '100%',
            scrollUpdatePos: true,
        });
    }, []);

    useEffect(() => {
        const AniContainer = window?.AniContainer;

        AniContainer.create({
            asyncFromTo: [
                ['.power-ocean-home-E .h5 .sec5-top .box1-ani', { opacity: 1, y: 0 }, { opacity: 0, y: -0 }, 0.4],
                ['.power-ocean-home-E .h5 .sec5-top .box2-ani', { opacity: 0, y: 0 }, { opacity: 1, y: 0 }, 0.4],
            ],
            asyncTimeLine: [0, 0.25],
            triggerElement: '.power-ocean-home-E',
            triggerHook: 1,
            offset: '100%',
            duration: '100%',
            scrollUpdatePos: true,
        });

        const videoLists = document.querySelectorAll('.power-ocean-home-E .h5 video');
        videoLists.forEach((videoList) => {
            const videoElement = videoList as HTMLVideoElement; // Typecast videoList to HTMLVideoElement
            AniContainer.create({
                triggerElement: videoList,
                triggerHook: 1,
                offset: 120,
                scrollUpdatePos: true,
                onEnter: () => {
                    videoElement.play(); // Call play() on videoElement
                },
                onLeave: () => {
                    videoElement.pause(); // Call pause() on videoElement
                    videoElement.currentTime = 0;
                },
            });
        });
    }, []);

    return (
        <div className={`power-ocean-home-E ${styles['power-ocean-home-E']}`}>
            <div className=" pc">
                <div className="sec5-top">
                    <div className="sticky">
                        <div className="wrapper-box">
                            <div className="video-box">
                                <EVideo
                                    className="video video-1 fullImgs"
                                    pc="https://websiteoss.ecoflow.com/upload/video/1768897906926/5_2.mp4"
                                    loop={false}
                                    aria-label={t`Start from
                                    only 1 battery`}
                                />
                            </div>
                            <div className="text-wrapper">
                                <div className="text-box box1">
                                    <div className="box1-ani">
                                        <h2 className="title">{t('title1')}</h2>
                                        <p className="desc">{t('desc1')}</p>
                                    </div>
                                </div>
                                <div className="text-box box2">
                                    <div className="box2-ani">
                                        <h2 className="title">{t('title2')}</h2>
                                        <p className="desc">{t('desc2')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sec5-bottom">
                    <div className="video-box">
                        <EVideo
                            className="video video-2 fullImgs"
                            pc="https://websiteoss.ecoflow.com/upload/video/1768897907100/5_3.mp4"
                            loop={false}
                            aria-label={t`Old or New?
                            Works just fine`}
                        />
                    </div>
                    <div className="text-box">
                        <h2 className="title">{t('title3')}</h2>
                        <p className="desc">{t('desc3')}</p>
                    </div>
                </div>
            </div>

            <div className=" h5">
                <div className="sec5-top">
                    <div className="sticky">
                        <div className="wrapper-box">
                            <div className="text-wrapper">
                                <div className="text-box box1">
                                    <div className="box1-ani">
                                        <p className="title">{t('title1')}</p>
                                        <p className="desc">{t('desc1')}</p>
                                    </div>
                                </div>
                                <div className="text-box box2">
                                    <div className="box2-ani">
                                        <h2 className="title">{t('title2')}</h2>
                                        <p className="desc">{t('desc2')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="video-box">
                                <EVideo
                                    className="video video-1 fullImgs"
                                    pc="https://websiteoss.ecoflow.com/upload/video/1768897906926/5_2.mp4"
                                    loop={false}
                                    aria-label={t`Start from
                                        only 1 battery`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sec5-bottom">
                    <div className="text-box">
                        <h2 className="title">{t('title3')}</h2>
                        <p className="desc">{t('desc3')}</p>
                    </div>
                    <div className="video-box">
                        <EVideo
                            className="video video-2 fullImgs"
                            pc="https://websiteoss.ecoflow.com/upload/video/1768897907100/5_3.mp4"
                            loop={false}
                            aria-label={t`Old or New?
                            Works just fine`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
